export function replaceFragments(fragments) {
	for (const [key, html] of Object.entries(fragments)) {
		const fragment = document.querySelector(
			`[data-fragment="${key}"]`,
		)

		if (!fragment) {
			continue
		}

		fragment.outerHTML = html
	}
}
